import Button from "@mui/material/Button";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { StyledDialog } from "../../styled/dialog";
import CircularLoading from "../loadingData/circularLoading";
import CustomDialog from "./customDialog";

const ConfirmDialog = ({
  open,
  handleClose,
  handleConfirm,
  title,
  text,
  warningText,
  loading,
  cancelText = "Cancelar",
  confirmText = "Aceptar"
}) => {
  return (
    <CustomDialog open={open} onClose={handleClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <p>{text}</p>
        <p>
          <strong>{warningText}</strong>
        </p>
      </DialogContent>
      {loading ? (
        <StyledDialog.LoadingContainer>
          <CircularLoading />
        </StyledDialog.LoadingContainer>
      ) : (
        <StyledDialog.Actions>
          <Button onClick={handleClose} color="primary">
            {cancelText}
          </Button>
          <Button onClick={handleConfirm} color="primary" variant="contained">
            {confirmText}
          </Button>
        </StyledDialog.Actions>
      )}
    </CustomDialog>
  );
};

export default ConfirmDialog;
